<template>
  <div style="width: 100%;height: 100%;">
    <div style="height: 100%">
    <iframe id="mainIframe"
            ref="mainIframe"
            name="mainIframe"
            style="width: 100%;height: 100%;margin: auto"
            src="../../../../static/newMonitorMap.html"
            frameborder="0"
            scrolling="no">
    </iframe>
    </div>
  </div>
</template>

<script>
import {querybinddevicelite} from '../../../api/alarmservice'
import {querydiseasename} from '../../../api/home'

export default {
  name: 'iframeMap',
  props: {
    mapCenter: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      imei: [],
      devices: [],
      orgid: '',
      dataviewalarm: '',
      oldpersons: [],
      viewAlarmOld: '',
      viewAlarmNew: '',
      isMap: false,
      isAll: false,
      allDevice: [],
      diseasenames: [],
      allCommunity: []
    }
  },
  created () {
    this.getDisease()
    this.golobleObject.childSend = this.childSendWeather
    this.golobleObject.childMapSend = this.getMqttMarkers // 地图加载完
    // mqtt獲取數據
    this.golobleObject.getAlarmMarker = this.addMarkerAlarmNew1
    this.golobleObject.clearMapMaker = this.clearMapOpen
    this.viewAlarmNew = this.dataviewalarm
    if (this.mapCenter.isJiaOld) {
    } else {
      this.getAllDevice()
    }
  },
  mounted () {
    let obj = {
      adcode: this.$store.state.user.LoginResp.adcode
    }
    // console.log(obj)
    setTimeout(() => {
      window.frames['mainIframe'].window.getStartMap(obj, this.mapCenter.isJiaOld)
    }, 2000)
  },
  methods: {
    // jiaold小区数据
    getRefresh (arr) {
      // console.log(66, arr)
      this.allCommunity = arr
      this.isAll = true
      this.getEndAllCommunity()
    },
    // 患病类型
    getDisease () {
      querydiseasename().then(res => {
        this.diseasenames = res.data.diseasenames
      }).catch(() => {})
    },
    getAllDevice () {
      this.allDevice = []
      querybinddevicelite().then(res => {
        // console.log('devices', res.data.devices)
        let devices = res.data.devices
        for (let i = 0; i < devices.length; i++) {
          if (devices[i].lng !== 0 && devices[i].lat !== 0) {
            this.allDevice.push(devices[i])
          }
        }
        this.isAll = true
        this.getEndAllDevice()
        // console.log('.devices', this.allDevice)
      }).catch(() => {})
    },
    // 上海显示设备
    getEndAllDevice () {
      if (this.isAll && this.isMap) {
        window.frames['mainIframe'].window.getParentCluster(this.allDevice)
      }
    },
    // jiaold 显示小区等
    getEndAllCommunity () {
      if (this.isAll && this.isMap) {
        // console.log(11, this.allCommunity)
        window.frames['mainIframe'].window.getCommunityCluster(this.allCommunity)
      }
    },
    childSendWeather (childValue) {
      let weatherObj = {
        weather: childValue.isweather.weather,
        temperature: childValue.isweather.temperature
      }
      this.$store.commit('set_weather', weatherObj)
      this.golobleObject.sendWeather()
    },
    // 地图加载完添加点
    getMqttMarkers () {
      this.isMap = true
      if (this.mapCenter.isJiaOld) {
        this.getEndAllCommunity()
      } else {
        // 上海
        this.getEndAllDevice()
      }
      if (this.dataviewalarm !== '') {
        this.addMarkerAlarmNew(this.dataviewalarm)
      }
    },
    addMarkerAlarmNew1 (alarm) { // 上海
      // console.log(9900, alarm)
      this.dataviewalarm = alarm
      this.addMarkerAlarmNew(alarm)
    },
    // 新mqtt推送请求数据
    addMarkerAlarmNew (alarm) { // 上海
      // console.log('地图', this.isMap, alarm)
      alarm.disease = ''
      if (alarm.OldPersonWithHome && alarm.OldPersonWithHome[0]) {
        alarm.disease = this.getDiseaseName(alarm.OldPersonWithHome[0].have_disease)
      }
      if (this.isMap) {
        window.frames['mainIframe'].window.getParentAddAlarm(alarm, this.viewAlarmOld)
      }
      this.viewAlarmOld = alarm
    },
    // 处理完事件清除地图点
    clearMapOpen (id) {
      window.frames['mainIframe'].window.getParentClearAlarm(id)
    },
    getDiseaseName (disease) {
      let name = '健康'
      if (disease !== '') {
        name = ''
        let arr = disease.split(',')
        let ids = []
        for (let i = 0; i < arr.length; i++) {
          ids.push(parseInt(arr[i]))
        }
        for (let i = 0; i < ids.length; i++) {
          name = this.getName(ids[i]) + ',' + name
        }
      }
      return name
    },
    getName (id) {
      for (let i = 0; i < this.diseasenames.length; i++) {
        if (parseInt(id) === this.diseasenames[i].id) {
          return this.diseasenames[i].name
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/monitoring/childComponents/iframeMap.vue